"use strict";
import { SOCKS_CONTROLLER_ADDRESSES, Token } from "@uniswap/sdk-core";
import { useAccount } from "hooks/useAccount";
import { useTokenBalance } from "lib/hooks/useCurrencyBalance";
import { useMemo } from "react";
import { UniverseChainId } from "features/chains/types";
const SOCKS_ADDRESS = SOCKS_CONTROLLER_ADDRESSES[UniverseChainId.Mainnet];
const SOCKS = SOCKS_ADDRESS ? new Token(UniverseChainId.Mainnet, SOCKS_ADDRESS, 0) : void 0;
export function useHasSocks() {
  const account = useAccount();
  const balance = useTokenBalance(account.address, account.chainId === UniverseChainId.Mainnet ? SOCKS : void 0);
  return useMemo(() => Boolean(balance?.greaterThan(0)), [balance]);
}
